// Constant Data for Cms::StoryGroup

export const ACTIVE_STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}
